import React, { useState, useEffect } from 'react';
import { Card, Select, Toast, Spin, Typography } from '@douyinfe/semi-ui';
import DataCubeCard from './DataCubeCard';
import request from '../../utils/request';
import { useLocation } from 'react-router-dom';

const dataTypes = [
  { value: 'daily_visit', label: '每日访问', dateType: 'daily' },
  { value: 'monthly_visit', label: '每月访问', dateType: 'monthly' },
  { value: 'weekly_visit', label: '每周访问', dateType: 'weekly' },
  { value: 'daily_retain', label: '每日留存', dateType: 'daily' },
  { value: 'monthly_retain', label: '每月留存', dateType: 'monthly' },
  { value: 'weekly_retain', label: '每周留存', dateType: 'weekly' },
  { value: 'daily_summary', label: '每日总览', dateType: 'daily' },
  { value: 'page_visit', label: '页面访问', dateType: 'daily' },
  { value: 'user_portrait', label: '用户画像', dateType: 'daily' },
  { value: 'visit_distribution', label: '访问分布', dateType: 'daily' }
];

const XcxDataCube = () => {
  const [loading, setLoading] = useState(false);
  const [applets, setApplets] = useState([]);
  const [selectedApplet, setSelectedApplet] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const uid = queryParams.get('uid');
    fetchApplets(uid);
  }, [location.search]);

  const fetchApplets = async (uid = null) => {
    setLoading(true);
    try {
      const response = await request.get('/go/sp/weixin/list_weixin_public/', {
        params: {
          public_type: 8, // 微信小程序
          limit: 100, // 获取所有小程序，可根据实际情况调整
          uids: uid // Add uid to filter applets if provided
        },
      });
      if (response.errno === 0) {
        const fetchedApplets = response.list || [];
        setApplets(fetchedApplets);
        if (uid && fetchedApplets.length > 0) {
          const preselectedApplet = fetchedApplets.find(item => item.uid == uid);
          if (preselectedApplet) {
            setSelectedApplet(preselectedApplet);
          }
        } else if (!uid && fetchedApplets.length > 0) {
          setSelectedApplet(fetchedApplets[0]);
        }
      } else {
        Toast.error(response.errstr || '获取小程序列表失败');
      }
    } catch (error) {
      console.error('获取小程序列表失败:', error);
      Toast.error('获取小程序列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleAppletChange = (value) => {
    const applet = applets.find((item) => item.uid === value);
    setSelectedApplet(applet);
  };

  return (
    <div style={{ padding: '20px' }}>
      <Typography.Title heading={3}>数据分析</Typography.Title>
      <div style={{ maxWidth: '500px', marginTop: '20px', marginBottom: '20px' }}>
        <div className="semi-form-field semi-form-field-select semi-form-field-required">
          <div className="semi-form-field-label">
            <label className="semi-form-field-label-text">选择小程序</label>
          </div>
          <Select
            placeholder="请选择小程序"
            loading={loading}
            onChange={handleAppletChange}
            value={selectedApplet?.uid}
            style={{ width: '100%' }}
          >
            {applets.map((applet) => (
              <Select.Option key={applet.uid} value={applet.uid}>
                {applet.public_name} ({applet.app_id})
              </Select.Option>
            ))}
          </Select>
          {!selectedApplet?.uid && !loading && applets.length > 0 && (
            <div className="semi-form-field-error-message">请选择小程序</div>
          )}
        </div>
      </div>

      {selectedApplet ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
          {dataTypes.map((type) => (
            <DataCubeCard
              key={type.value}
              dataType={type.value}
              title={type.label}
              dateType={type.dateType}
              appId={selectedApplet.uid}
              subType={type.subType}
            />
          ))}
        </div>
      ) : (
        <Spin spinning={loading}>
          <div style={{ height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {!loading && applets.length === 0 && <p>暂无可用小程序数据，请先关联小程序。</p>}
          </div>
        </Spin>
      )}
    </div>
  );
};

export default XcxDataCube;